import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Layout from '../Layout/index';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import renderSelectField from '../../shared/components/form/Select';
import renderTextInput from '../../shared/components/form/TextInput';
import showNotifications from '../../containers/Preferences/notificationMessages';
import { faList, faThLarge } from '@fortawesome/free-solid-svg-icons';
import PlusIcon from 'mdi-react/PlusIcon';
import axios from 'axios';
import ls from 'local-storage';
import TaskItem from './components/ListView/TaskItem';
import withReactContent from 'sweetalert2-react-content';

import {
  DndContext,
  closestCorners,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
  useDroppable,
} from '@dnd-kit/core';

import {
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable';
import TaskContainer from './components/ListView/TaskContainer';
import TaskTableContainer from './components/TableView/TaskTableContainer';
import TaskKanban from './components/KanbanView/TaskKanban';
import FormTask from './components/FormTask';
import TaskNotification from './components/TaskNotification';

import './index.scss';
import Swal from 'sweetalert2';
import TaskTableItem from './components/TableView/TaskTableItem';
import { connectWs } from '../../socket';

const TaskManagement = ({ t, reset }) => {
  const [auth] = useState({
    token: ls.get('token'),
    apiws: ls.get('ws_ip'),
    emp_id: ls.get('user_cred').emp_id,
    usr_id: ls.get('user_cred').usr_id,
  });

  // const [hasCreate, setHasCreate] = useState(false);
  const [touched, setTouched] = useState(false);
  const [viewType, setViewType] = useState(ls.get('viewType') ?? 'tableView');

  const [dragOverlayItem, setDragOverlayItem] = useState({
    id: null,
    data: {},
  });
  const [errMessage, setErrMessage] = useState('');
  const [loading, setLoading] = useState(true);

  const [defaultSection, setDefaultSection] = useState([]);
  const [itemSections, setItemSections] = useState([]);
  const [addSection, setAddSection] = useState({
    // check add section comes from my task or shared task
    mySection: false,
    sharedSection: false,
  });
  const [itemSectionPersonals, setItemSectionPersonals] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    isEdit: false,
    data: {
      pta_id: '',
      title: '',
      description: '',
      startDate: '',
      endDate: '',
      assignee: '',
      priority: '',
    },
  });

  const [isOpen, setIsOpen] = useState(false);

  const idRenameSectionActive = useRef('all');
  const typeSection = useRef(null);
  const refSocket = useRef(null);
  const lastIndex = useRef(0);
  const [sectionName, setSectionName] = useState('');

  const [filter, setFilter] = useState({
    status: '',
    priority: '',
  });

  const [priority, setPriority] = useState([]);
  const [user, setUser] = useState([]);
  const [activeTab, setActiveTab] = useState('1');

  const [notificationOpen, setNotificationOpen] = useState(false);

  const sensors = useSensors(
    useSensor(PointerSensor),
    // useSensor(KeyboardSensor, {
    //   coordinateGetter: sortableKeyboardCoordinates,
    // }),
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
        delay: 200,
      },
    }),
  );

  const activeTaskDrag = useRef(null);

  const overContainerDraggable = useRef('');

  const toggleOffCanvas = (page, sectionId, tab) => {
    if (page == 'new') {
      setModalData({
        isEdit: false,
        data: {
          pps_id: tab === 1 ? sectionId : null,
          pse_id: tab === 2 ? sectionId : null,
        },
      });
      setModalOpen(!modalOpen);
      setIsOpen(!isOpen);
    } else if (page == 'edit') {
      setModalData({
        isEdit: true,
      });
      setModalOpen(!modalOpen);
      setIsOpen(!isOpen);
    } else {
      setModalOpen(!modalOpen);
      setIsOpen(!isOpen);
      getDataSection();
    }
  };

  const toggleNotification = () => {
    setNotificationOpen(!notificationOpen);
    if (notificationOpen == false) {
      setTimeout(() => {
        setNotificationOpen(false);
      }, 2000);
    }
  };

  const handleChangeSection = (event) => {
    const value = event?.target?.value;
    if (value == 'Done' || value == 'Archive') {
      setErrMessage("Section name can't be same as the default section");
      setTouched(true);
    } else if (!value) {
      setErrMessage("Section name shouldn't be empty");
      setTouched(true);
    } else {
      setErrMessage('');
      setTouched(false);
    }

    setSectionName(event?.target?.value); // set input section name
  };

  // init socket comment
  const initWebSocket = useCallback(() => {
    const onWSMessage = (message) => {
      let tab = [];
      setActiveTab((prev) => {
        tab.push(prev);
        return prev;
      });

      let usrId = ls.get('user_cred').usr_id; // user id logged in
      let empId = ls.get('user_cred').emp_id; // emp id logged in

      const jsonMessage = JSON.parse(message.data);

      switch (jsonMessage.type) {
        case 'CREATE_SECTION':
          if (jsonMessage.tab == 1) {
            setItemSectionPersonals((prev) => {
              prev.splice(2, 0, jsonMessage.data);

              return prev;
            });
          } else {
            setItemSections((prev) => {
              prev.splice(2, 0, jsonMessage.data);

              return prev;
            });
          }

          break;

        case 'RENAME_SECTION':
          if (jsonMessage.tab == 1) {
            setItemSectionPersonals((prev) =>
              prev.map((value) => {
                if (value.pps_id == jsonMessage.data.pps_id) {
                  value.section_name = jsonMessage.data.section_name;
                }

                return value;
              }),
            );
          } else {
            setItemSections((prev) =>
              prev.map((value) => {
                if (value.pse_id == jsonMessage.data.pse_id) {
                  value.section_name = jsonMessage.data.section_name;
                }

                return value;
              }),
            );
          }

          break;

        case 'DELETE_SECTION':
          if (jsonMessage.tab == 1) {
            setItemSectionPersonals((prev) =>
              prev.filter((value) => {
                return value.pps_id !== jsonMessage.data.pps_id;
              }),
            );
          } else {
            setItemSections((prev) =>
              prev.filter((value) => {
                return value.pse_id !== jsonMessage.data.pse_id;
              }),
            );
          }

          break;

        case 'REORDER_SECTION':
          // const orderSection = jsonMessage.data.sort(
          //   (a, b) => b.seqtion_sequences - a.seqtion_sequences,
          // );
          // console.log(jsonMessage, 'hehehe');

          // if (jsonMessage.tab == 1) {
          //   setItemSectionPersonals((prev) => {
          //     prev.filter
          //   })
          // } else {
          //   setItemSections(orderSection);
          // }

          // setTimeout(() => {
          //   console.log(itemSectionPersonals, 'hehe', itemSections);
          // }, 5000);
          // getDataSection();

          break;

        case 'CREATE_TASK':
          if (tab.toString() == 1) {
            setItemSectionPersonals((prev) => {
              let section = prev?.map((value) => {
                if (value.pps_id == jsonMessage.data.pps_id) {
                  value.tasks = [jsonMessage.data, ...value.tasks];
                }

                return value;
              });

              return section;
            });
          } else if (tab.toString() == 2) {
            setItemSections((prev) => {
              let section = prev?.map((value) => {
                if (value.pse_id == jsonMessage.data.pse_id) {
                  value.tasks = [jsonMessage.data, ...value.tasks];
                }

                return value;
              });

              return section;
            });
          }

          break;

        case 'UPDATE_TASK':
          getDataSection();

          break;

        case 'DELETE_TASK':
          if (tab.toString() == 1) {
            setItemSectionPersonals((prev) =>
              prev.map((value) => {
                if (value.pps_id == jsonMessage.data.pps_id) {
                  let tasks = value.tasks.filter((value) => {
                    return value.pta_id !== jsonMessage.data.pta_id;
                  });

                  value.tasks = tasks;
                }

                return value;
              }),
            );
          } else if (tab.toString() == 2) {
            setItemSections((prev) =>
              prev.map((value) => {
                if (value.pse_id == jsonMessage.data.pse_id) {
                  let tasks = value.tasks.filter((value) => {
                    return value.pta_id !== jsonMessage.data.pta_id;
                  });

                  value.tasks = tasks;
                }

                return value;
              }),
            );
          }

          break;

        case 'DONE_TASK':
          if (tab.toString() == 1) {
            setItemSectionPersonals((prev) => {
              const section = prev?.filter((value) => {
                if (value?.pps_id == jsonMessage?.data?.pps_id) {
                  // socket archive task
                  value.tasks = [jsonMessage?.data, ...value.tasks];
                } else {
                  // socket unarchive task
                  let tasks = value.tasks.filter((value) => {
                    return value.pta_id !== jsonMessage?.data?.pta_id;
                  });

                  value.tasks = tasks;
                }

                return value;
              });

              return section;
            });
          } else {
            setItemSections((prev) => {
              const section = prev?.filter((value) => {
                if (value?.pse_id == jsonMessage?.data?.pse_id) {
                  // socket archive task
                  value.tasks = [jsonMessage?.data, ...value.tasks];
                } else {
                  // socket unarchive task
                  let tasks = value.tasks.filter((value) => {
                    return value.pta_id !== jsonMessage?.data?.pta_id;
                  });

                  value.tasks = tasks;
                }

                return value;
              });

              return section;
            });
          }

          break;

        case 'ARCHIVE_TASK':
          if (tab.toString() == 1) {
            setItemSectionPersonals((prev) => {
              const section = prev?.filter((value) => {
                if (value?.pps_id == jsonMessage?.data?.pps_id) {
                  // socket archive task
                  value.tasks = [jsonMessage?.data, ...value.tasks];
                } else {
                  // socket unarchive task
                  let tasks = value.tasks.filter((value) => {
                    return value.pta_id !== jsonMessage?.data?.pta_id;
                  });

                  value.tasks = tasks;
                }

                return value;
              });

              return section;
            });
          } else {
            setItemSections((prev) => {
              const section = prev?.filter((value) => {
                if (value?.pse_id == jsonMessage?.data?.pse_id) {
                  // socket archive task
                  value.tasks = [jsonMessage?.data, ...value.tasks];
                } else {
                  // socket unarchive task
                  let tasks = value.tasks.filter((value) => {
                    return value.pta_id !== jsonMessage?.data?.pta_id;
                  });

                  value.tasks = tasks;
                }

                return value;
              });

              return section;
            });
          }

          break;

        case 'REORDER_TASK':
          setItemSectionPersonals((prev) => {
            // takes section thas has task
            let sectionHaveTask = prev?.filter((val) => {
              return val?.tasks.length !== 0;
            });

            let sections = prev?.map((value) => {
              if (jsonMessage?.data?.pps_id == value?.pps_id) {
                let order = jsonMessage?.data?.task_order - 1;
                let taskFiltered = value?.tasks?.filter((val) => {
                  return val?.pta_id !== jsonMessage?.data?.pta_id;
                });

                // assign object is edit task by user login
                jsonMessage.data = Object.assign({}, jsonMessage.data, {
                  is_edit: sectionHaveTask[0]?.tasks[0]?.is_edit ?? false,
                  adming_access:
                    sectionHaveTask[0]?.tasks[0]?.admin_access ?? false,
                });

                taskFiltered?.splice(order, 0, jsonMessage?.data);

                value.tasks = taskFiltered;
              } else {
                let taskFiltered = value?.tasks?.filter((val) => {
                  return val?.pta_id !== jsonMessage?.data?.pta_id;
                });

                value.tasks = taskFiltered;
              }

              return value;
            });

            return sections;
          });

          setItemSections((prev) => {
            let sectionHaveTask = prev?.filter((val) => {
              return val?.tasks.length !== 0;
            });

            let sections = prev?.map((value) => {
              if (jsonMessage?.data?.pse_id == value?.pse_id) {
                let order = jsonMessage?.data?.task_order - 1;
                let taskFiltered = value?.tasks?.filter((val) => {
                  return val?.pta_id !== jsonMessage?.data?.pta_id;
                });

                // assign object is edit task by user login
                jsonMessage.data = Object.assign({}, jsonMessage.data, {
                  is_edit: sectionHaveTask[0]?.tasks[0]?.is_edit ?? false,
                  adming_access:
                    sectionHaveTask[0]?.tasks[0]?.admin_access ?? false,
                });

                taskFiltered?.splice(order, 0, jsonMessage?.data);

                value.tasks = taskFiltered;
              } else {
                let taskFiltered = value?.tasks?.filter((val) => {
                  return val?.pta_id !== jsonMessage?.data?.pta_id;
                });

                value.tasks = taskFiltered;
              }

              return value;
            });

            return sections;
          });

          break;

        default:
          break;
      }
    };

    const { socket, socketTimeout } = connectWs(
      'wss://service.phirogo.com/ws',
      onWSMessage,
    );

    refSocket.current = { socket, socketTimeout };
  }, [itemSectionPersonals, itemSections]);

  const getDataSection = () => {
    setLoading(true);
    // TO FETCHING DATA SECTION
    const config = {
      headers: {
        Authorization: `bearer ${auth.token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    const emp_id = ls.get('user_cred').emp_id;

    const formFilter = new FormData();
    formFilter.append('status', filter.status);
    formFilter.append('priority', filter.priority);
    formFilter.append('emp_id', emp_id);
    activeTab == '1'
      ? formFilter.append('tab', 1)
      : formFilter.append('tab', 2);

    axios
      .post(`${auth.apiws}/Task/getAllSectionWithTask`, formFilter, config)
      .then((response) => {
        if (response.data.status == 'ok') {
          setLoading(false);
          // setIsLoading(false);
          let dataResponse = response.data.data;
          let defaultSection = [];

          if (activeTab == '2') {
            setItemSections(dataResponse);
          } else {
            setItemSectionPersonals(dataResponse);
          }

          // get section name default section
          dataResponse.map((val) => {
            if (val.default_section) {
              defaultSection.push(val.section_name);
            }
          });

          setDefaultSection(defaultSection);

          // if (dataResponse[0].tasks) {
          //   let arr = [];
          //   dataResponse?.map((item) => {
          //     let renameSection = false;

          //     if (activeTab == '2') {
          //       if (item.pse_id == idRenameSectionActive.current) {
          //         renameSection = true;
          //       }
          //       arr.push({
          //         pse_id: item.pse_id,
          //         personal: false,
          //         section_name: item.section_name,
          //         rename_section: renameSection,
          //         tasks: item.tasks,
          //         has_edit: item.has_edit,
          //         default_section: item?.default_section || false,
          //       });
          //     } else {
          //       if (item?.pps_id == idRenameSectionActive.current) {
          //         renameSection = true;
          //       }
          //       arr.push({
          //         pps_id: item?.pps_id,
          //         personal: true,
          //         section_name: item?.section_name,
          //         rename_section: renameSection,
          //         tasks: item?.tasks,
          //         has_edit: item.has_edit,
          //         default_section: item?.default_section,
          //       });
          //     }
          //   });

          //   if (activeTab == '2') {
          //     setItemSections(arr);
          //   } else {
          //     setItemSectionPersonals(arr);
          //   }
          // } else {
          //   if (activeTab == '2') {
          //     setItemSections(dataResponse);
          //   } else {
          //     setItemSectionPersonals(dataResponse);
          //   }
          // }
          setLoading(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getPriority = () => {
    // TO FETCHING PRIORITY OPTION
    // setIsLoading(true);

    const config = {
      headers: {
        Authorization: `bearer ${auth.token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    axios
      .post(`${auth.apiws}/Task/getallpriority`, '', config)
      .then((response) => {
        // setIsLoading(false);
        if (response.data.status == 'ok') {
          // setIsLoading(false);
          const dataResponse = response.data.data;
          const arr = [];

          dataResponse.map((item) => {
            arr.push({
              value: item.tpr_id,
              label: item.priority_name,
            });
          });
          setPriority(arr);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
      });
  };

  const getDetailTask = (id) => {
    // TO FETCHING DETAIL EDIT
    const config = {
      headers: {
        Authorization: `bearer ${auth.token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    axios
      .post(`${auth.apiws}/Task/getDetailTaskById/${id}`, '', config)
      .then((response) => {
        // setIsLoading(false);
        if (response.data.status == 'ok') {
          // setIsLoading(false);
          let dataResponse = response.data.data;

          dataResponse.map((item) => {
            setModalData({
              isEdit: true,
              data: {
                pta_id: item.pta_id,
                title: item.task_name,
                description: item.task_description,
                startDate: item.task_start,
                endDate: item.task_finish,
                assignee: item.task_assignee,
                priority: item.tpr_id,
              },
            });
          });

          // setItemSections(dataResponse);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
      });
  };

  const getUser = () => {
    // TO FETCHING ASSIGNE USER ADD AND EDIT TASK
    let url = `${auth.apiws}/task/getAllEmpSub`;
    const config = {
      headers: {
        Authorization: `bearer ${auth.token}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        if (response.data.status == 'ok') {
          const dataResponse = response.data.data;
          const arr = [];

          dataResponse.map((item) => {
            arr.push({
              value: item.emp_id,
              label: item.emp_name,
            });
          });
          setUser(arr);
        } else {
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const saveSection = (e) => {
    e.preventDefault();

    let error = false;
    let url = `${auth.apiws}/section/saveItem`;

    const formData = new FormData();
    formData.append('section_name', sectionName);
    formData.append('cuser_id', ls.get('user_cred').usr_id);

    if (addSection.mySection) {
      formData.append('personal', true);
      formData.append('emp_id', ls.get('user_cred').emp_id);
    } else {
      formData.append('personal', false);
    }

    if (!sectionName) {
      setErrMessage("Section name shouldn't be empty");
      setTouched(true);
      error = true;
    } else if (sectionName == 'Done' || sectionName == 'Archive') {
      setErrMessage("Section name can't be same as the default section");
      setTouched(true);
      error = true;
    }

    const config = {
      headers: {
        Authorization: `bearer ${auth.token}`,
        'Content-Type': 'multipart/form-data',
      },
    };

    if (!error) {
      axios
        .post(url, formData, config)
        .then((response) => {
          if (response.data.status == 'ok') {
            showNotifications('Success', 'Submit Submission', 'success');
            setTouched(false);
            setSectionName('');
            setAddSection({
              mySection: false,
              sharedSection: false,
            });
            getDataSection();
            reloadData();
            reset();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const reloadData = () => {
    getDataSection();
  };

  useEffect(() => {
    getDataSection();
  }, [activeTab]);

  useEffect(() => {
    initWebSocket();
    getPriority();
    getUser();

    return () => {
      refSocket.current.socket.close();
      clearTimeout(refSocket.current.socketTimeout);
    };
  }, []);

  useEffect(() => {
    getDataSection();
  }, [filter]);

  return (
    <>
      <div style={{ opacity: 1 }}>
        <FormTask
          t={t}
          toggleOffCanvas={toggleOffCanvas}
          modalData={modalData}
          priority={priority}
          user={user}
          activeTab={activeTab}
          isOpen={isOpen}
        />
      </div>
      <Layout />
      {notificationOpen && (
        <>
          <TaskNotification
            TaskNotification
            data={{
              title: t('LBL.TASKDONETITLE'),
              description: t('LBL.TASKDONESUBTITLE'),
            }}
            toggleNotification={toggleNotification}
            notificationOpen={notificationOpen}
          ></TaskNotification>
        </>
      )}
      <div className="container__wrap" id="tm__wrap">
        <Container className="pt-3">
          <div className="tm__inner">
            <div className="tab__task-management">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab == '1' ? 'active' : ''}
                    onClick={() => {
                      setActiveTab('1');
                      setSectionName('');
                      setTouched(false);
                      reset();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          activeTab === '1'
                            ? '/img/icon-box.svg'
                            : '/img/icon-box-white.svg'
                        }
                        alt=""
                      />
                      <span className="ml-2">{t('LBL.MYTASKTITLE')}</span>
                    </div>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab == '2' ? 'active' : ''}
                    onClick={() => {
                      setActiveTab('2');
                      setSectionName('');
                      setTouched(false);
                      reset();
                    }}
                  >
                    <img
                      src={
                        activeTab === '2'
                          ? '/img/icon-box.svg'
                          : '/img/icon-box-white.svg'
                      }
                      alt=""
                    />
                    <span className="ml-2">{t('LBL.SHAREDTASKTITLE')}</span>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
            <TabContent
              activeTab={activeTab}
              className="tab__content-management"
              style={{
                paddingBottom: viewType == 'kanbanView' ? '0px' : '30px',
              }}
            >
              {/* My Task */}
              <TabPane tabId="1" className="">
                <div className="tm__inner-header">
                  <Row>
                    <Col md={3} className="mb-3 mb-md-0">
                      <h5 className="title">{t('LBL.MYTASKTITLE')}</h5>
                      <div className="desc">{t('LBL.MYTASKSUBTITLE')}</div>
                    </Col>
                    <Col md={9}>
                      <Row className="align-items-center ml-0">
                        <Col
                          md={2}
                          className="ml-auto text-right pl-0 mb-3 mb-md-0"
                        >
                          {/* TABLE VIEW  */}
                          <button
                            className="btn-filter"
                            onClick={() => {
                              setViewType('tableView');
                              ls.set('viewType', 'tableView');
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faList}
                              className="fa-fw"
                              style={{
                                color:
                                  viewType == 'tableView'
                                    ? '#1696FF'
                                    : '#999999',
                              }}
                            />
                          </button>
                          {/* LIST VIEW  */}
                          <button
                            className="btn-filter"
                            onClick={() => {
                              setViewType('listView');
                              ls.set('viewType', 'listView');
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faThLarge}
                              className="fa-fw"
                              style={{
                                color:
                                  viewType == 'listView'
                                    ? '#1696FF'
                                    : '#999999',
                              }}
                            />
                          </button>
                          {/* KANBAN VIEW  */}
                          <button
                            className="btn-filter"
                            onClick={() => {
                              setViewType('kanbanView');
                              ls.set('viewType', 'kanbanView');
                            }}
                          >
                            <svg
                              class="svg-inline--fa fa-list fa-w-16 fa-fw"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.70078 0.799805C1.46209 0.799805 1.23317 0.894626 1.06439 1.06341C0.895602 1.23219 0.800781 1.46111 0.800781 1.6998V3.4998C0.800781 3.7385 0.895602 3.96742 1.06439 4.1362C1.23317 4.30498 1.46209 4.3998 1.70078 4.3998H6.20078C6.43948 4.3998 6.66839 4.30498 6.83718 4.1362C7.00596 3.96742 7.10078 3.7385 7.10078 3.4998V1.6998C7.10078 1.46111 7.00596 1.23219 6.83718 1.06341C6.66839 0.894626 6.43948 0.799805 6.20078 0.799805H1.70078ZM1.70078 6.1998C1.46209 6.1998 1.23317 6.29463 1.06439 6.46341C0.895602 6.63219 0.800781 6.86111 0.800781 7.0998V8.8998C0.800781 9.1385 0.895602 9.36742 1.06439 9.5362C1.23317 9.70498 1.46209 9.7998 1.70078 9.7998H6.20078C6.43948 9.7998 6.66839 9.70498 6.83718 9.5362C7.00596 9.36742 7.10078 9.1385 7.10078 8.8998V7.0998C7.10078 6.86111 7.00596 6.63219 6.83718 6.46341C6.66839 6.29463 6.43948 6.1998 6.20078 6.1998H1.70078ZM1.70078 11.5998C1.46209 11.5998 1.23317 11.6946 1.06439 11.8634C0.895602 12.0322 0.800781 12.2611 0.800781 12.4998V14.2998C0.800781 14.5385 0.895602 14.7674 1.06439 14.9362C1.23317 15.105 1.46209 15.1998 1.70078 15.1998H6.20078C6.43948 15.1998 6.66839 15.105 6.83718 14.9362C7.00596 14.7674 7.10078 14.5385 7.10078 14.2998V12.4998C7.10078 12.2611 7.00596 12.0322 6.83718 11.8634C6.66839 11.6946 6.43948 11.5998 6.20078 11.5998H1.70078ZM9.80078 0.799805C9.56209 0.799805 9.33317 0.894626 9.16439 1.06341C8.9956 1.23219 8.90078 1.46111 8.90078 1.6998V3.4998C8.90078 3.7385 8.9956 3.96742 9.16439 4.1362C9.33317 4.30498 9.56209 4.3998 9.80078 4.3998H14.3008C14.5395 4.3998 14.7684 4.30498 14.9372 4.1362C15.106 3.96742 15.2008 3.7385 15.2008 3.4998V1.6998C15.2008 1.46111 15.106 1.23219 14.9372 1.06341C14.7684 0.894626 14.5395 0.799805 14.3008 0.799805H9.80078ZM9.80078 6.1998C9.56209 6.1998 9.33317 6.29463 9.16439 6.46341C8.9956 6.63219 8.90078 6.86111 8.90078 7.0998V8.8998C8.90078 9.1385 8.9956 9.36742 9.16439 9.5362C9.33317 9.70498 9.56209 9.7998 9.80078 9.7998H14.3008C14.5395 9.7998 14.7684 9.70498 14.9372 9.5362C15.106 9.36742 15.2008 9.1385 15.2008 8.8998V7.0998C15.2008 6.86111 15.106 6.63219 14.9372 6.46341C14.7684 6.29463 14.5395 6.1998 14.3008 6.1998H9.80078Z"
                                fill={
                                  viewType == 'kanbanView'
                                    ? '#1696FF'
                                    : '#999999'
                                }
                              />
                            </svg>
                          </button>
                        </Col>
                        <Col md={3} className="pl-0 mb-3 mb-md-0 form">
                          <Field
                            name="status"
                            component={renderSelectField}
                            placeholder="Select Status"
                            className="select-status"
                            options={[
                              { value: 0, label: 'Active' },
                              { value: 1, label: 'Done' },
                              { value: 2, label: 'Archived' },
                            ]}
                            onChange={(e) => {
                              // console.log(e);
                              setFilter((prev) => ({
                                ...prev,
                                status: e.value,
                              }));
                            }}
                          />
                        </Col>
                        <Col md={5} className="pl-0 mb-3 mb-md-0">
                          <div className="select-priority d-flex align-items-center form">
                            <Field
                              name="priority"
                              component={renderSelectField}
                              placeholder="Select Priority"
                              className="select-prority"
                              options={priority}
                              onChange={(e) => {
                                // console.log(e);
                                setFilter((prev) => ({
                                  ...prev,
                                  priority: e.value,
                                }));
                              }}
                            />
                            <button
                              className="btn btn-primary btn-add-task"
                              style={{
                                whiteSpace: 'nowrap',
                              }}
                              onClick={() => toggleOffCanvas('new')}
                            >
                              {t('LBL.ADDTASK')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                {itemSectionPersonals?.length != 0 ? (
                  <>
                    {viewType == 'listView' && (
                      <>
                        <div className="tm__inner-wrapper">
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCorners}
                            onDragStart={handleDragStart}
                            onDragOver={handleDragOverPersonal}
                            onDragEnd={handleDragEndPersonal}
                          >
                            {itemSectionPersonals?.map((item) => {
                              return (
                                <TaskContainer
                                  t={t}
                                  tab={activeTab}
                                  section={item}
                                  sectionId={{ pps_id: item.pps_id }}
                                  titleCollapse={item.section_name}
                                  reloadSection={reloadData}
                                  createSect={() => console.log('asd')}
                                  lastIndex={lastIndex.current++}
                                  idActiveSection={idRenameSectionActive}
                                  handleRenameSection={(val) => {
                                    typeSection.current = 'personal';
                                    idRenameSectionActive.current =
                                      val?.pps_id ?? val;
                                    reloadData();
                                  }}
                                  dragOverlayItem={dragOverlayItem.data}
                                  getDetailTask={getDetailTask}
                                  getDataSection={getDataSection}
                                  id={item.section_name}
                                  tasks={item?.tasks ? item.tasks : null}
                                  toggleOffCanvas={toggleOffCanvas}
                                  toggleNotification={toggleNotification}
                                  user={user}
                                />
                              );
                            })}
                            <DragOverlay>
                              {dragOverlayItem.id ? (
                                <TaskItem
                                  t={t}
                                  tab={activeTab}
                                  key={dragOverlayItem.id}
                                  id={dragOverlayItem.id}
                                  data={dragOverlayItem.data}
                                  toggleOffCanvas={toggleOffCanvas}
                                  toggleNotification={toggleNotification}
                                  getDetailTask={getDetailTask}
                                  getDataSection={getDataSection}
                                  user={user}
                                />
                              ) : null}
                            </DragOverlay>
                          </DndContext>
                        </div>
                      </>
                    )}

                    {viewType == 'tableView' && (
                      <>
                        <div className="tm__inner-wrapper">
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCorners}
                            onDragStart={handleDragStart}
                            onDragOver={handleDragOverPersonal}
                            onDragEnd={handleDragEndPersonal}
                          >
                            {itemSectionPersonals?.map((item) => {
                              return (
                                <TaskTableContainer
                                  t={t}
                                  tab={1}
                                  section={item}
                                  sectionId={{ pps_id: item.pps_id }}
                                  titleCollapse={item.section_name}
                                  reloadSection={reloadData}
                                  createSect={() => console.log('asd')}
                                  lastIndex={lastIndex.current++}
                                  idActiveSection={idRenameSectionActive}
                                  handleRenameSection={(val) => {
                                    typeSection.current = 'personal';
                                    idRenameSectionActive.current =
                                      val?.pps_id ?? val;
                                    reloadData();
                                  }}
                                  dragOverlayItem={dragOverlayItem.data}
                                  getDetailTask={getDetailTask}
                                  getDataSection={getDataSection}
                                  id={item.section_name}
                                  tasks={item?.tasks ? item.tasks : null}
                                  toggleOffCanvas={toggleOffCanvas}
                                  toggleNotification={toggleNotification}
                                  user={user}
                                  priority={priority}
                                  activeTaskDrag={activeTaskDrag}
                                />
                              );
                            })}
                            <DragOverlay>
                              {dragOverlayItem.id ? (
                                <table className="table table-hover task-tableview-overlay">
                                  <tbody>
                                    <TaskTableItem
                                      t={t}
                                      tab={1}
                                      key={dragOverlayItem.id}
                                      id={dragOverlayItem.id}
                                      data={dragOverlayItem.data}
                                      toggleOffCanvas={toggleOffCanvas}
                                      toggleNotification={toggleNotification}
                                      getDetailTask={getDetailTask}
                                      getDataSection={getDataSection}
                                      user={user}
                                    />
                                  </tbody>
                                </table>
                              ) : null}
                            </DragOverlay>
                          </DndContext>
                        </div>
                      </>
                    )}

                    {viewType == 'kanbanView' && (
                      <>
                        <div className="tm__inner-wrapper">
                          <div id="taskKanbanView">
                            <TaskKanban
                              t={t}
                              items={itemSectionPersonals}
                              toggleOffCanvas={toggleOffCanvas}
                              toggleNotification={toggleNotification}
                              getDataSection={getDataSection}
                              reloadSection={reloadData}
                              activeTab={1}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {loading != true && (
                      <div className="mt-5 text-center">
                        <img
                          src="/img/empty-state-task.png"
                          alt=""
                          width={250}
                        />
                        <h5 className="text-primary mt-3 mb-1">
                          No Task assigned to you
                        </h5>
                        <div>
                          You don’t have any active task, Click on add button to
                          create yours !
                        </div>
                      </div>
                    )}
                  </>
                )}

                {viewType != 'kanbanView' && (
                  <>
                    {!addSection.mySection ? (
                      <button
                        className="button__add-section px-0 text-muted"
                        onClick={() => {
                          setTouched(false);
                          setAddSection((prev) => ({
                            mySection: true,
                            sharedSection: false,
                          }));
                        }}
                      >
                        <PlusIcon
                          className="mr-2"
                          style={{ height: 14, width: 14 }}
                        />
                        {t('LBL.ADDSECTION')}
                      </button>
                    ) : (
                      <Col md={6} className="px-0 mt-2">
                        <form
                          className="form"
                          id="formSection"
                          onSubmit={saveSection}
                        >
                          <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                            <input
                              id="section_name"
                              name="section_name"
                              type="text"
                              placeholder={t('LBL.ADDSECTION')}
                              onChange={handleChangeSection}
                            />
                            {(!sectionName ||
                              sectionName == 'Done' ||
                              sectionName == 'Archive') &&
                            touched ? (
                              <span className="form__form-group-error">
                                {errMessage}
                              </span>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className="mt-3">
                            <button
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => {
                                setTouched(false);
                                setAddSection((prev) => ({
                                  mySection: false,
                                  sharedSection: true,
                                }));
                              }}
                            >
                              {t('LBL.CANCEL')}
                            </button>
                            <button type="submit" className="btn btn-primary">
                              {t('FRM.SAVE')}
                            </button>
                          </div>
                        </form>
                      </Col>
                    )}
                  </>
                )}
              </TabPane>

              {/* Shared Task */}
              <TabPane tabId="2" className="">
                <div className="tm__inner-header">
                  <Row>
                    <Col md={3} className="mb-3 mb-md-0">
                      <h5 className="title">{t('LBL.SHAREDTASKTITLE')}</h5>
                      <div className="desc">{t('LBL.SENTTASKSUBTITLE')}</div>
                    </Col>
                    <Col md={9}>
                      <Row className="align-items-center ml-0">
                        <Col
                          md={2}
                          className="ml-auto text-right pl-0 mb-3 mb-md-0"
                        >
                          {/* TABLE VIEW  */}
                          <button
                            className="btn-filter"
                            onClick={() => {
                              setViewType('tableView');
                              ls.set('viewType', 'tableView');
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faList}
                              className="fa-fw"
                              style={{
                                color:
                                  viewType == 'tableView'
                                    ? '#1696FF'
                                    : '#999999',
                              }}
                            />
                          </button>
                          {/* LIST VIEW  */}

                          <button
                            className="btn-filter"
                            onClick={() => {
                              setViewType('listView');
                              ls.set('viewType', 'listView');
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faThLarge}
                              className="fa-fw"
                              style={{
                                color:
                                  viewType == 'listView'
                                    ? '#1696FF'
                                    : '#999999',
                              }}
                            />
                          </button>
                          {/* KANBAN VIEW  */}
                          <button
                            className="btn-filter"
                            onClick={() => {
                              setViewType('kanbanView');
                              ls.set('viewType', 'kanbanView');
                            }}
                          >
                            <svg
                              class="svg-inline--fa fa-list fa-w-16 fa-fw"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.70078 0.799805C1.46209 0.799805 1.23317 0.894626 1.06439 1.06341C0.895602 1.23219 0.800781 1.46111 0.800781 1.6998V3.4998C0.800781 3.7385 0.895602 3.96742 1.06439 4.1362C1.23317 4.30498 1.46209 4.3998 1.70078 4.3998H6.20078C6.43948 4.3998 6.66839 4.30498 6.83718 4.1362C7.00596 3.96742 7.10078 3.7385 7.10078 3.4998V1.6998C7.10078 1.46111 7.00596 1.23219 6.83718 1.06341C6.66839 0.894626 6.43948 0.799805 6.20078 0.799805H1.70078ZM1.70078 6.1998C1.46209 6.1998 1.23317 6.29463 1.06439 6.46341C0.895602 6.63219 0.800781 6.86111 0.800781 7.0998V8.8998C0.800781 9.1385 0.895602 9.36742 1.06439 9.5362C1.23317 9.70498 1.46209 9.7998 1.70078 9.7998H6.20078C6.43948 9.7998 6.66839 9.70498 6.83718 9.5362C7.00596 9.36742 7.10078 9.1385 7.10078 8.8998V7.0998C7.10078 6.86111 7.00596 6.63219 6.83718 6.46341C6.66839 6.29463 6.43948 6.1998 6.20078 6.1998H1.70078ZM1.70078 11.5998C1.46209 11.5998 1.23317 11.6946 1.06439 11.8634C0.895602 12.0322 0.800781 12.2611 0.800781 12.4998V14.2998C0.800781 14.5385 0.895602 14.7674 1.06439 14.9362C1.23317 15.105 1.46209 15.1998 1.70078 15.1998H6.20078C6.43948 15.1998 6.66839 15.105 6.83718 14.9362C7.00596 14.7674 7.10078 14.5385 7.10078 14.2998V12.4998C7.10078 12.2611 7.00596 12.0322 6.83718 11.8634C6.66839 11.6946 6.43948 11.5998 6.20078 11.5998H1.70078ZM9.80078 0.799805C9.56209 0.799805 9.33317 0.894626 9.16439 1.06341C8.9956 1.23219 8.90078 1.46111 8.90078 1.6998V3.4998C8.90078 3.7385 8.9956 3.96742 9.16439 4.1362C9.33317 4.30498 9.56209 4.3998 9.80078 4.3998H14.3008C14.5395 4.3998 14.7684 4.30498 14.9372 4.1362C15.106 3.96742 15.2008 3.7385 15.2008 3.4998V1.6998C15.2008 1.46111 15.106 1.23219 14.9372 1.06341C14.7684 0.894626 14.5395 0.799805 14.3008 0.799805H9.80078ZM9.80078 6.1998C9.56209 6.1998 9.33317 6.29463 9.16439 6.46341C8.9956 6.63219 8.90078 6.86111 8.90078 7.0998V8.8998C8.90078 9.1385 8.9956 9.36742 9.16439 9.5362C9.33317 9.70498 9.56209 9.7998 9.80078 9.7998H14.3008C14.5395 9.7998 14.7684 9.70498 14.9372 9.5362C15.106 9.36742 15.2008 9.1385 15.2008 8.8998V7.0998C15.2008 6.86111 15.106 6.63219 14.9372 6.46341C14.7684 6.29463 14.5395 6.1998 14.3008 6.1998H9.80078Z"
                                fill={
                                  viewType == 'kanbanView'
                                    ? '#1696FF'
                                    : '#999999'
                                }
                              />
                            </svg>
                          </button>
                        </Col>
                        <Col md={3} className="pl-0 mb-3 mb-md-0 form">
                          <Field
                            name="status"
                            component={renderSelectField}
                            placeholder="Select Status"
                            className="select-status"
                            options={[
                              { value: 0, label: 'Active' },
                              { value: 1, label: 'Done' },
                              { value: 2, label: 'Archived' },
                            ]}
                            onChange={(e) => {
                              // console.log(e);
                              setFilter((prev) => ({
                                ...prev,
                                status: e.value,
                              }));
                            }}
                          />
                        </Col>
                        <Col md={5} className="pl-0 mb-3 mb-md-0">
                          <div className="select-priority d-flex align-items-center form">
                            <Field
                              name="priority"
                              component={renderSelectField}
                              placeholder="Select Priority"
                              className="select-prority"
                              options={priority}
                              onChange={(e) => {
                                // console.log(e);
                                setFilter((prev) => ({
                                  ...prev,
                                  priority: e.value,
                                }));
                              }}
                            />
                            <button
                              className="btn btn-primary btn-add-task"
                              style={{
                                whiteSpace: 'nowrap',
                              }}
                              onClick={() => toggleOffCanvas('new')}
                            >
                              {t('LBL.ADDTASK')}
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                {itemSections.length != 0 ? (
                  <>
                    {viewType == 'listView' && (
                      <>
                        <div className="tm__inner-wrapper">
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCorners}
                            onDragStart={handleDragStart}
                            onDragOver={handleDragOver}
                            onDragEnd={handleDragEnd}
                          >
                            {itemSections?.map((item) => {
                              return (
                                <TaskContainer
                                  t={t}
                                  tab={activeTab}
                                  section={item}
                                  sectionId={{ pse_id: item.pse_id }}
                                  titleCollapse={item.section_name}
                                  reloadSection={reloadData}
                                  lastIndex={lastIndex.current++}
                                  idActiveSection={idRenameSectionActive}
                                  handleRenameSection={(val) => {
                                    typeSection.current = 'shared';
                                    idRenameSectionActive.current =
                                      val?.pse_id ?? val;
                                    reloadData();
                                  }}
                                  dragOverlayItem={dragOverlayItem.data}
                                  getDetailTask={getDetailTask}
                                  getDataSection={getDataSection}
                                  id={item.section_name}
                                  tasks={item?.tasks ? item?.tasks : null}
                                  toggleOffCanvas={toggleOffCanvas}
                                  toggleNotification={toggleNotification}
                                  user={user}
                                />
                              );
                            })}
                            <DragOverlay>
                              {dragOverlayItem.id ? (
                                <TaskItem
                                  t={t}
                                  tab={activeTab}
                                  key={dragOverlayItem.id}
                                  id={dragOverlayItem.id}
                                  data={dragOverlayItem.data}
                                  toggleOffCanvas={toggleOffCanvas}
                                  toggleNotification={toggleNotification}
                                  getDetailTask={getDetailTask}
                                  getDataSection={getDataSection}
                                  user={user}
                                />
                              ) : null}
                            </DragOverlay>
                          </DndContext>
                        </div>
                      </>
                    )}

                    {viewType == 'tableView' && (
                      <>
                        <div className="tm__inner-wrapper">
                          <DndContext
                            sensors={sensors}
                            collisionDetection={closestCorners}
                            onDragStart={handleDragStart}
                            onDragOver={handleDragOver}
                            onDragEnd={handleDragEnd}
                          >
                            {itemSections?.map((item) => {
                              return (
                                <TaskTableContainer
                                  t={t}
                                  tab={2}
                                  section={item}
                                  sectionId={{ pse_id: item.pse_id }}
                                  titleCollapse={item.section_name}
                                  reloadSection={reloadData}
                                  lastIndex={lastIndex.current++}
                                  idActiveSection={idRenameSectionActive}
                                  handleRenameSection={(val) => {
                                    typeSection.current = 'shared';
                                    idRenameSectionActive.current =
                                      val?.pse_id ?? val;
                                    reloadData();
                                  }}
                                  dragOverlayItem={dragOverlayItem.data}
                                  getDetailTask={getDetailTask}
                                  getDataSection={getDataSection}
                                  id={item.section_name}
                                  tasks={item?.tasks ? item?.tasks : null}
                                  toggleOffCanvas={toggleOffCanvas}
                                  toggleNotification={toggleNotification}
                                  user={user}
                                  priority={priority}
                                />
                              );
                            })}
                            <DragOverlay>
                              {dragOverlayItem.id ? (
                                <table className="table table-hover task-tableview-overlay">
                                  <tbody>
                                    <TaskTableItem
                                      t={t}
                                      tab={2}
                                      key={dragOverlayItem.id}
                                      id={dragOverlayItem.id}
                                      data={dragOverlayItem.data}
                                      toggleOffCanvas={toggleOffCanvas}
                                      toggleNotification={toggleNotification}
                                      getDetailTask={getDetailTask}
                                      getDataSection={getDataSection}
                                      user={user}
                                    />
                                  </tbody>
                                </table>
                              ) : null}
                            </DragOverlay>
                          </DndContext>
                        </div>
                      </>
                    )}

                    {viewType == 'kanbanView' && (
                      <>
                        <div className="tm__inner-wrapper">
                          <div id="taskKanbanView">
                            <TaskKanban
                              t={t}
                              items={itemSections}
                              toggleOffCanvas={toggleOffCanvas}
                              toggleNotification={toggleNotification}
                              getDataSection={getDataSection}
                              reloadSection={reloadData}
                              activeTab={2}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {loading != true && (
                      <div className="mt-5 text-center">
                        <img
                          src="/img/empty-state-task.png"
                          alt=""
                          width={250}
                        />
                        <h5 className="text-primary mt-3 mb-1">
                          No Task assigned to you
                        </h5>
                        <div>
                          You don’t have any active task, Click on add button to
                          create yours !
                        </div>
                      </div>
                    )}
                  </>
                )}

                {viewType != 'kanbanView' && (
                  <>
                    {!addSection.sharedSection ? (
                      <button
                        className="button__add-section px-0 text-muted"
                        onClick={() => {
                          setTouched(false);
                          setAddSection((prev) => ({
                            mySection: false,
                            sharedSection: true,
                          }));
                        }}
                      >
                        <PlusIcon
                          className="mr-2"
                          style={{ height: 14, width: 14 }}
                        />
                        {t('LBL.ADDSECTION')}
                      </button>
                    ) : (
                      <Col md={6} className="px-0 mt-2">
                        <form
                          className="form ss"
                          id="formSection"
                          onSubmit={saveSection}
                        >
                          <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
                            <input
                              id="section_name"
                              name="section_name"
                              type="text"
                              placeholder={t('LBL.ADDSECTION')}
                              onChange={handleChangeSection}
                            />
                            {(!sectionName ||
                              sectionName == 'Done' ||
                              sectionName == 'Archive') &&
                            touched ? (
                              <span className="form__form-group-error">
                                {errMessage}
                              </span>
                            ) : (
                              ''
                            )}
                          </div>
                          <div className="mt-3">
                            <button
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => {
                                setTouched(false);
                                setAddSection((prev) => ({
                                  mySection: false,
                                  sharedSection: false,
                                }));
                              }}
                            >
                              {t('LBL.CANCEL')}
                            </button>
                            <button className="btn btn-primary" type="submit">
                              {t('FRM.SAVE')}
                            </button>
                          </div>
                        </form>
                      </Col>
                    )}
                  </>
                )}
              </TabPane>
            </TabContent>
          </div>
        </Container>
      </div>
    </>
  );

  function findContainer(id) {
    const container = itemSectionPersonals.find((section) => {
      return section.tasks.find((task) => task.pta_id == id);
    });

    if (container) {
      return container;
    }

    return itemSectionPersonals.find((section) =>
      section.section_name.includes(id),
    );
  }

  function handleDragStart(event) {
    const { active } = event;
    if (active.data.current === 'section') {
      return;
    }
    const temp = active.data.current.sortable.items.filter(
      (val) => val.pta_id == active.id,
    );

    activeTaskDrag.current = active.id;

    setDragOverlayItem({
      id: active.id,
      data: temp[0],
    });
  }

  // MOVE IN DIFFERENT CONTAINER
  function handleDragOver(event) {
    const { active, over } = event;
    if (active == null || over == null) {
      return;
    }
    const { id } = active;
    const { id: overId } = over;

    const activeContainer =
      findContainer(id)?.section_name ??
      active.data?.current?.sortable?.containerId;
    const overContainer =
      findContainer(overId)?.section_name ??
      over.data?.current?.sortable?.containerId;

    if (!activeContainer || !overContainer) {
      return;
    }
    if (activeContainer === overContainer) {
      handleReorderSameContainer(activeContainer, active.id, over.id, 2);
      return;
    }

    setItemSections((prev) => {
      const updatedSections = [...prev];
      const activeSectionIndex = updatedSections.findIndex(
        (section) => section.section_name === activeContainer,
      );
      const overSectionIndex = updatedSections.findIndex(
        (section) => section.section_name === overContainer,
      );

      if (activeSectionIndex !== -1 && overSectionIndex !== -1) {
        const activeSection = updatedSections[activeSectionIndex];
        const overSection = updatedSections[overSectionIndex];

        const activeIndex = activeSection.tasks.findIndex(
          (task) => task.pta_id === id,
        );
        const overIndex = overSection.tasks.findIndex(
          (task) => task.pta_id === overId,
        );

        if (activeIndex !== -1) {
          const movedTask = activeSection.tasks.splice(activeIndex, 1)[0];

          if (overIndex !== -1) {
            overSection.tasks.splice(overIndex, 0, movedTask);
          } else {
            // If the target task is not found, move the task to the end
            overSection.tasks.push(movedTask);
          }
        }
      }

      // SET FORMDATA
      let updateArr = [];
      updatedSections.map((item) => {
        let dataTemp = {};
        item.tasks.map((data, index) => {
          const reversedIndex = item.tasks.length - 1 - index;
          dataTemp = {
            pse_id: item.pse_id,
            order: reversedIndex,
            pta_id: data.pta_id,
            section_status: item?.section_status,
          };
          updateArr.push(dataTemp);
        });
      });

      // UPDATE ORDER
      const config = {
        headers: {
          Authorization: `bearer ${auth.token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };
      const formFilter = new FormData();
      formFilter.append('data', JSON.stringify(updateArr));
      formFilter.append('pta_id', active.id);
      formFilter.append('tab', activeTab);

      axios
        .post(`${auth.apiws}/Task/updateSectionOnDrag`, formFilter, config)
        .then((response) => {
          // getDataSection();
        })
        .catch((error) => {
          // setIsLoading(false);
          console.log(error);
        });

      // RETURN NEW SECTION TO FETCHING DATA
      return updatedSections;
    });
  }

  // MOVE IN ONE CONTAINER
  function handleDragEnd(event) {
    const { active, over } = event;
    // pengecekan data status
    if (!active || !over) {
      setDragOverlayItem({
        id: null,
        data: {},
      });
      return;
    }
    if (active?.id !== over?.id) {
      const overSectionName =
        typeof over.id === 'number'
          ? over.data?.current?.sortable?.containerId
          : over.id;
      const activeSectionName = active.data?.current?.sortable?.containerId;

      setItemSections((sections) => {
        const activeSectionIndex = sections.findIndex(
          (section) => section.section_name == activeSectionName,
        );
        const overSectionIndex = sections.findIndex(
          (section) => section.section_name == overSectionName,
        );
        if (activeSectionIndex !== -1 && overSectionIndex !== -1) {
          const activeTaskIndex = sections[activeSectionIndex].tasks.findIndex(
            (task) => task.pta_id == active.id,
          );
          const overTaskIndex =
            typeof over.id === 'number'
              ? sections[overSectionIndex].tasks.findIndex(
                  (task) => task.pta_id == over.id,
                )
              : -1;
          const activeTask =
            sections[activeSectionIndex].tasks[activeTaskIndex];
          sections[activeSectionIndex].tasks.splice(activeTaskIndex, 1);
          if (overTaskIndex !== -1) {
            sections[overSectionIndex].tasks.splice(
              overTaskIndex,
              0,
              activeTask,
            );
          } else {
            sections[overSectionIndex].tasks.push(activeTask);
          }
        }

        // SET FORMDATA
        let updateArr = [];
        sections.map((item) => {
          let dataTemp = {};
          item.tasks.map((data, index) => {
            const reversedIndex = item.tasks.length - 1 - index;
            dataTemp = {
              pse_id: item.pse_id,
              order: reversedIndex,
              pta_id: data.pta_id,
              section_status: item?.section_status,
            };
            updateArr.push(dataTemp);
          });
        });
        // UPDATE ORDER
        const config = {
          headers: {
            Authorization: `bearer ${auth.token}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        };
        const formFilter = new FormData();
        formFilter.append('data', JSON.stringify(updateArr));
        formFilter.append('pta_id', active.id);
        formFilter.append('tab', activeTab);

        axios
          .post(`${auth.apiws}/Task/updateSectionOnDrag`, formFilter, config)
          .then((response) => {
            // getDataSection();
          })
          .catch((error) => {
            // setIsLoading(false);
            console.log(error);
          });

        // RETURN NEW SECTION TO FETCHING DATA
        return sections;
      });
    }

    setDragOverlayItem({
      id: null,
      data: {},
    });
  }

  // MOVE IN DIFFERENT CONTAINER
  function handleDragOverPersonal(event) {
    const { active, over } = event;
    if (active == null || over == null) {
      return;
    }
    // if drag SECTION
    if (active.data.current == 'section') {
      if (over.data === null) {
        return;
      }
      overContainerDraggable.current =
        over.data?.current?.sortable?.containerId;

      return;
    }
    const { id } = active;
    const { id: overId } = over;

    const activeContainer =
      findContainer(id)?.section_name ??
      active.data?.current?.sortable?.containerId;
    const overContainer =
      findContainer(overId)?.section_name ??
      over.data?.current?.sortable?.containerId;

    if (!activeContainer || !overContainer) {
      return;
    }
    if (activeContainer === overContainer) {
      handleReorderSameContainer(activeContainer, active.id, over.id);
      return;
    }

    setItemSectionPersonals((prev) => {
      const updatedSections = [...prev];
      const activeSectionIndex = updatedSections.findIndex(
        (section) => section.section_name === activeContainer,
      );
      const overSectionIndex = updatedSections.findIndex(
        (section) => section.section_name === overContainer,
      );

      if (activeSectionIndex !== -1 && overSectionIndex !== -1) {
        const activeSection = updatedSections[activeSectionIndex];
        const overSection = updatedSections[overSectionIndex];

        const activeIndex = activeSection.tasks.findIndex(
          (task) => task.pta_id === id,
        );
        const overIndex = overSection.tasks.findIndex(
          (task) => task.pta_id === overId,
        );

        if (activeIndex !== -1) {
          const movedTask = activeSection.tasks.splice(activeIndex, 1)[0];

          if (overIndex !== -1) {
            overSection.tasks.splice(overIndex, 0, movedTask);
          } else {
            // If the target task is not found, move the task to the end
            overSection.tasks.push(movedTask);
          }
        }
      }

      // SET FORMDATA
      let updateArr = [];
      updatedSections.map((item) => {
        let dataTemp = {};
        item.tasks.map((data, index) => {
          const reversedIndex = item.tasks.length - 1 - index;
          dataTemp = {
            pps_id: item.pps_id,
            order: reversedIndex,
            pta_id: data.pta_id,
            section_status: item?.section_status,
          };
          updateArr.push(dataTemp);
        });
      });

      // UPDATE ORDER
      const config = {
        headers: {
          Authorization: `bearer ${auth.token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      };
      const formFilter = new FormData();
      formFilter.append('data', JSON.stringify(updateArr));
      formFilter.append('pta_id', active.id);
      formFilter.append('tab', activeTab);

      axios
        .post(`${auth.apiws}/Task/updateSectionOnDrag`, formFilter, config)
        .then((response) => {
          // getDataSection();
        })
        .catch((error) => {
          // setIsLoading(false);
          console.log(error);
        });

      // RETURN NEW SECTION TO FETCHING DATA
      return updatedSections;
    });
  }

  function handleReorderSameContainer(containerId, active, over, tab) {
    if (tab == 2) {
      setItemSections((prev) => {
        const updatedSections = [...prev];
        const activeSectionIndex = updatedSections.findIndex(
          (section) => section.section_name === containerId,
        );
        if (activeSectionIndex !== -1) {
          const activeTaskIndex = updatedSections[
            activeSectionIndex
          ].tasks.findIndex((item) => item.pta_id == active);
          const overTaskIndex = updatedSections[
            activeSectionIndex
          ].tasks.findIndex((item) => item.pta_id == over);
          const activeTask =
            updatedSections[activeSectionIndex].tasks[activeTaskIndex];
          if (overTaskIndex !== -1) {
            updatedSections[activeSectionIndex].tasks.splice(
              activeTaskIndex,
              1,
            );
            updatedSections[activeSectionIndex].tasks.splice(
              overTaskIndex,
              0,
              activeTask,
            );
          }
        }
        return updatedSections;
      });
    }
    setItemSectionPersonals((prev) => {
      const updatedSections = [...prev];
      const activeSectionIndex = updatedSections.findIndex(
        (section) => section.section_name === containerId,
      );
      if (activeSectionIndex !== -1) {
        const activeTaskIndex = updatedSections[
          activeSectionIndex
        ].tasks.findIndex((item) => item.pta_id == active);
        const overTaskIndex = updatedSections[
          activeSectionIndex
        ].tasks.findIndex((item) => item.pta_id == over);
        const activeTask =
          updatedSections[activeSectionIndex].tasks[activeTaskIndex];
        if (overTaskIndex !== -1) {
          updatedSections[activeSectionIndex].tasks.splice(activeTaskIndex, 1);
          updatedSections[activeSectionIndex].tasks.splice(
            overTaskIndex,
            0,
            activeTask,
          );
        }
      }
      return updatedSections;
    });
  }

  // MOVE IN ONE CONTAINER
  function handleDragEndPersonal(event) {
    const { active, over } = event;
    activeTaskDrag.current = null;
    // pengecekan data status
    if (!active || !over) {
      setDragOverlayItem({
        id: null,
        data: {},
      });
      return;
    }
    // if reordering SECTION
    if (active.data.current === 'section') {
      const activeSectionName = active.id;
      let overSectionName = over.id;
      if (defaultSection.includes(overSectionName.split('-')[1])) {
        // conditions where only the default section cannot be reordered
        return false;
      }
      if (over.data.current === 'section') {
        overSectionName = over.id.split('-')[1];
      }
      if (typeof overSectionName == 'number') {
        overSectionName = over.data.current.sortable.containerId;
      }

      if (
        !activeSectionName ||
        !overSectionName ||
        activeSectionName === overSectionName
      ) {
        return;
      }
      if (activeTab == 1) {
        setItemSectionPersonals((sections) => {
          let updatedSections = [...sections];
          console.log(updatedSections);
          const activeSectionIndex = updatedSections.findIndex(
            (section) => section.section_name === activeSectionName,
          );
          const overSectionIndex = updatedSections.findIndex(
            (section) => section.section_name === overSectionName,
          );
          if (activeSectionIndex === 0 || overSectionIndex === 0) {
            return updatedSections;
          }
          if (activeSectionIndex !== -1 && overSectionIndex !== -1) {
            const activeSection = updatedSections[activeSectionIndex];
            updatedSections.splice(activeSectionIndex, 1);
            updatedSections.splice(overSectionIndex, 0, activeSection);
            const pps_ids = updatedSections.map((item) => item.pps_id);
            // UPDATE ORDER
            const config = {
              headers: {
                Authorization: `bearer ${auth.token}`,
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            };
            const formData = new FormData();
            formData.append('pps_ids', pps_ids);
            formData.append('emp_id', auth.emp_id);
            formData.append('muser_id', auth.usr_id);

            axios
              .post(`${auth.apiws}/Section/reorderSection`, formData, config)
              .then((response) => {
                getDataSection();
              })
              .catch((error) => {
                // setIsLoading(false);
                console.log(error);
              });
            return updatedSections;
          }
        });
      } else {
        setItemSections((sections) => {
          let updatedSections = [...sections];
          const activeSectionIndex = updatedSections.findIndex(
            (section) => section.section_name === activeSectionName,
          );
          const overSectionIndex = updatedSections.findIndex(
            (section) => section.section_name === overSectionName,
          );
          if (activeSectionIndex === 0 || overSectionIndex === 0) {
            return updatedSections;
          }
          if (activeSectionIndex !== -1 && overSectionIndex !== -1) {
            const activeSection = updatedSections[activeSectionIndex];
            updatedSections.splice(activeSectionIndex, 1);
            updatedSections.splice(overSectionIndex, 0, activeSection);
            const pse_ids = updatedSections.map((item) => item.pse_id);
            // UPDATE ORDER
            const config = {
              headers: {
                Authorization: `bearer ${auth.token}`,
                'Content-Type': 'application/x-www-form-urlencoded',
              },
            };
            const formData = new FormData();
            formData.append('pse_ids', pse_ids);
            formData.append('emp_id', auth.emp_id);
            formData.append('muser_id', auth.usr_id);

            axios
              .post(`${auth.apiws}/Section/reorderSection`, formData, config)
              .then((response) => {
                getDataSection();
              })
              .catch((error) => {
                // setIsLoading(false);
                console.log(error);
              });
            return updatedSections;
          }
        });
      }
      return;
    }

    if (active?.id !== over?.id) {
      setItemSectionPersonals((sections) => {
        const updatedSections = sections.map((section) => {
          const updatedTasks = section.tasks.slice(); // Copy tasks array to avoid mutation
          const activeIndex = updatedTasks.findIndex(
            (task, i) => task.pta_id === active.id,
          );
          const overIndex = updatedTasks.findIndex(
            (task, i) => task.pta_id === over.id,
          );

          // Ensure both active and over items are found
          if (activeIndex !== -1 && overIndex !== -1) {
            // Move the active item to the over position
            const [movedItem] = updatedTasks.splice(activeIndex, 1);
            updatedTasks.splice(overIndex, 0, movedItem);
          }

          return {
            ...section,
            tasks: updatedTasks,
          };
        });

        // SET FORMDATA
        let updateArr = [];
        updatedSections.map((item) => {
          let dataTemp = {};
          item.tasks.map((data, index) => {
            const reversedIndex = item.tasks.length - 1 - index;
            dataTemp = {
              pps_id: item.pps_id,
              order: reversedIndex,
              pta_id: data.pta_id,
              section_status: item?.section_status,
            };
            updateArr.push(dataTemp);
          });
        });

        // UPDATE ORDER
        const config = {
          headers: {
            Authorization: `bearer ${auth.token}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        };
        const formFilter = new FormData();
        formFilter.append('data', JSON.stringify(updateArr));
        formFilter.append('pta_id', active.id);
        formFilter.append('tab', activeTab);

        axios
          .post(`${auth.apiws}/Task/updateSectionOnDrag`, formFilter, config)
          .then((response) => {
            // getDataSection();
          })
          .catch((error) => {
            // setIsLoading(false);
            console.log(error);
          });

        // RETURN NEW SECTION TO FETCHING DATA
        return updatedSections;
      });
    }

    setDragOverlayItem({
      id: null,
      data: {},
    });
  }
};

export default reduxForm({
  form: 'FormSection',
  destroyOnUnmount: true,
})(translate('global')(TaskManagement));
